import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const IDENTITY_ENDPOINT = `${BASE_URL}/rest/v1.0/accounts`;
export const IDENTITY_IMAGE_ENDPOINT = `${IDENTITY_ENDPOINT}/image`;
export const PENDING_IDENTITIES = `${IDENTITY_ENDPOINT}?status=PENDING_APPROVAL`;
export const PUT_PENDING_IDENTITY = IDENTITY_ENDPOINT;
